// node modules
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
// actions
import { getCheckoutsArchive, getReservesCheckoutArchive } from '../../../redux/checkouts/archives/actions';
// Constants
import { checkoutsReportReservesColumns } from '../../../enums/columns/checkoutsReportReservation';
// Components
import Table from '../../../components/table';
import Spin from '../../../components/loading';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';
// utils
import submitForm from '../../../utils/submitForm';

const initialFormValue = { trackingNumber: '', fromDate: '', toDate: '' };

function ReservesCheckoutArchiveModal(props) {
  let formRefrence = useRef();
  const dispatch = useDispatch();
  const state = useSelector(state => state.checkoutsArchiveReducer);

  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({ sortType: 'asc', sortBy: 'endAt', sortQuery: '', filterQuery: '' });
  const [formData, setFormData] = useState(initialFormValue);
  const [error, setError] = useState('');

  // functions :
  const closeModal = () => {
    props.setShowModal('');
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${sort.sortQuery || 'endAt-asc'}`;
      if (sort.filterQuery) {
        query += '&' + sort.filterQuery;
      }
      return query;
    }
  };

  const sortTable = (columnName) => {
    const sortType = sort.sortType === 'asc' ? 'desc' : 'asc';
    setSort({ ...sort, sortType, sortBy: columnName });
  };

  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(currentPage, 10);
    dispatch(getReservesCheckoutArchive(props.selectedRecordId, searchQuery));
  };

  const onPageChanged = pageNumber => {
    setCurrentPage(pageNumber);
    const query = buildSearchQuery(pageNumber, 10);
    dispatch(getReservesCheckoutArchive(props.selectedRecordId, query));
  };

  const applyFilters = (event) => {
    event.preventDefault();
    if (!error) {
      const queryString = submitForm(event);
      setSort({ ...sort, filterQuery: queryString });
    }
  };

  const resetForm = () => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setFormData(initialFormValue);
    setSort({ ...sort, filterQuery: '' });
  };

  const handleEndDataChange = (val) => {
    setFormData({ ...formData, toDate: val });
    if (formData.fromDate > val) {
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
    } else {
      setError('');
    }
  };

  const handleStartDateChange = (val) => {
    setFormData({ ...formData, fromDate: val });
    if (val <= formData.toDate) {
      setError('');
    } else if (val > formData.toDate) {
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
    }
  };

  useEffect(() => {
    sortTable(sort.sortBy);
  }, []);

  useEffect(() => {
    const sortQuery = `${sort.sortBy}-${sort.sortType}`;
    setSort({ ...sort, sortQuery });
  }, [sort.sortType]);

  useEffect(() => {
    setCurrentPage(currentPage);
    filterAndSort();
  }, [sort.sortQuery]);

  useEffect(() => {
    setCurrentPage(currentPage);
    filterAndSort();
  }, [sort.filterQuery]);

  return (
    <Modal isOpen={props.showReserveModal === 'reservation'} size='xl'>
      <ModalHeader>
          <span className='modal-title'>
            ‍‍‍‍‍{`آرشیو رزروهای مرتبط به کافه ${props.selectedCafeName}`}
          </span>
        <span
          title={locales('labels.close.modal')}
          className='modal-close'
          onClick={closeModal}
        >
            close
          </span>
      </ModalHeader>
      <div className='filter-part'>
        <form
          onReset={event => resetForm(event)}
          onSubmit={event => applyFilters(event)}
          id="form"
          ref={formRefrence}
          className="my-4"
        >
          <div className="col-12 d-flex justify-content-between">
            <label className="col-1 text-right filter-field-label p-0">{locales('fields.reserveCode')}</label>
            <input
              name="trackingNumberPart"
              type="text"
              value={formData.trackingNumber}
              onChange={event => setFormData({ ...formData, trackingNumber: event.target.value })}
              className="form-control col-3"
              placeholder={locales('fields.reserveCode')}
              id="trackingNumberPart"
            />
            <span className="col-1 text-right filter-field-label p-0">{locales('labels.reserve.date')}</span>
            از
            <DatePicker
              marge={true}
              placeholder="تاریخ شروع"
              name="fromDate"
              className="form-control col-2"
              value={formData.fromDate}
              onChange={(value) => handleStartDateChange(value)}
            />
            تا
            <DatePicker
              marge={true}
              placeholder="تاریخ پایان"
              name="toDate"
              className="form-control col-2"
              value={formData.toDate}
              onChange={v => handleEndDataChange(v)}
            />
          </div>
          {error && <div style={{ color: 'red', fontSize: '0.8rem', textAlign: 'end' }}>{error}</div>}
          <br/>
          <div className="mr-auto" style={{ textAlign: 'center' }}>
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
              maxLength="10"
            />
            <button
              type="submit"
              id="apply-filter-btn-cafe"
              className="btn btn-success w-5 mx-2"
              name="filter"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </form>
      </div>
      <ModalBody>
        <Spin
          spinning={state.getReservesCheckoutArchiveLoading}
        >
          {
            state.getReservesCheckoutArchiveError ? (
              <div className='alert alert-danger'>
                {locales('messages.server.error')}
              </div>
            ) : (
              <div className='container'>
                {state.getReservesCheckoutArchiveFailed &&
                <div className='alert alert-danger'>{state.getReservesCheckoutArchiveMessage}</div>}
              </div>
            )}
        </Spin>
        <Table
          columns={checkoutsReportReservesColumns}
          dataSource={state.checkoutArchiveReserves}
          loading={state.getReservesCheckoutArchiveLoading}
          action={{}}
          sort={{ type: sort.sortType, action: sortTable }}
          pagination={{
            currentPage: currentPage,
            pageSize: 10,
            totalCount: state.checkoutArchiveReserve.totalRecords,
            onPageChange: onPageChanged,
          }}
        />
      </ModalBody>
      <ModalFooter>
        <button
          className='btn btn-light mx-1'
          onClick={closeModal}
          disabled={state.loading}
        >
          {locales('labels.close.modal')}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default ReservesCheckoutArchiveModal;
